var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer } from "@mui/material";
import { CreateElectionEventScreen } from "./CreateScreen";
import { useCreateElectionEventStore } from "@/providers/CreateElectionEventContextProvider";
export var CreateDataDrawer = function (_a) {
    var open = _a.open, closeDrawer = _a.closeDrawer;
    var _b = useCreateElectionEventStore(), createDrawer = _b.createDrawer, closeCreateDrawer = _b.closeCreateDrawer;
    return (_jsx(_Fragment, { children: _jsx(Drawer, __assign({ anchor: "right", open: createDrawer, onClose: closeCreateDrawer, PaperProps: {
                sx: { width: "30%" },
            } }, { children: _jsx(CreateElectionEventScreen, {}) })) }));
};
